import React from 'react';
import {connect} from 'react-redux';
import Descriptions from './descriptions';
import ParameterDescriptions from './parameter-description';


/**
 * Request description in live console tab 
 */
 var hasQueryParams = false;
 var hasBodyParams = false;
 var pathParams = [];
 var jsTree = {};
 var headerParams = [];

class DescriptionInLiveConsole extends React.Component
{

   render()
   {
        hasQueryParams = (this.props.hasQueryParams == undefined) ? false: this.props.hasQueryParams;
        hasBodyParams = (this.props.hasBodyParams == undefined) ? false: this.props.hasBodyParams;
        pathParams = (this.props.pathParams == undefined) ? []: this.props.pathParams;
        jsTree = this.props.jsTree == undefined ? [] : this.props.jsTree;
        headerParams = (this.props.headerParameters == undefined) ? []: this.props.headerParameters;

       return(
            <div id = "descriptionsTab">
                    {
                    hasBodyParams &&
                    <div id = "requestDescriptionsTab">
                            <Descriptions
                                jsTree={jsTree}
                                display = "block"
                                parent = "root"
                                type = "request"
                            />
                    </div>
                    }
                    {hasQueryParams &&
                    <ParameterDescriptions type = "Query" src="request"/>  
                    }
                    {pathParams.length > 0 &&
                    <ParameterDescriptions type="Path" src="request"/>  
                    }
                     {headerParams.length > 0 &&
                        <ParameterDescriptions type="Header" src="request"/>  
                    }
            </div>
       );

    }
}
function mapStateToProps(state){
    return{      
        hasQueryParams: state.rhsReducer.hasQueryParams,
        hasBodyParams : state.lhsReducer.hasBodyParams,
        pathParams: state.rhsReducer.pathParameters,
        jsTree: state.rhsReducer.jsTree,
        headerParams : state.rhsReducer.headerParameters
    };
   
}

export default connect(mapStateToProps)(DescriptionInLiveConsole);